import React from "react";
import FrequencyMap from "./FrequencyMap.tsx"; // Assuming your FrequencyMap component is in the same directory

interface Props {
  rsid: string;
  gene: string;
  isOpen: boolean;
  onClose: () => void;
}

function Modal({ rsid, gene, isOpen, onClose }: Props) {
  if (!isOpen) return null;

  return (
    <>
      {/* Bootstrap Modal Backdrop */}
      <div 
        className="modal-backdrop fade show" 
        style={{ zIndex: 1040 }}
        onClick={onClose}
      ></div>

      {/* Bootstrap Modal */}
      <div 
        className="modal fade show d-block" 
        style={{ zIndex: 1050 }}
        tabIndex={-1}
        role="dialog"
        aria-labelledby="rsidModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header" style={{ backgroundColor: "#003366", color: "white" }}>
              <h5 className="modal-title" id="rsidModalLabel">
                Allele Frequency Map - {gene} ({rsid})
              </h5>
              <button 
                type="button" 
                className="btn-close btn-close-white" 
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body p-4">
              <div className="row mb-3">
                <div className="col-md-6">
                  <h6 className="text-muted">Gene:</h6>
                  <p className="fw-bold">{gene}</p>
                </div>
                <div className="col-md-6">
                  <h6 className="text-muted">rsID:</h6>
                  <p className="fw-bold">{rsid}</p>
                </div>
              </div>

              {/* Map Container */}
              <div className="border rounded p-3" style={{ backgroundColor: "#f8f9fa" }}>
                <FrequencyMap geneName={gene} rsIDs={[rsid]} showTable={true} />
              </div>

              {/* Additional Info */}
              <div className="mt-3">
              
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onClose}
              >
                Close
              </button>
            
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Modal;